/* =============================================
   SUNBUNN ATHLETICA — sales.js
   Conversion Rate Optimization Scripts
   ============================================= */

(function () {
  'use strict';

  /* ===== EXIT-INTENT POPUP ===== */
  let exitShown = false;

  window.closeExitPopup = function () {
    document.getElementById('exit-popup').classList.remove('open');
    sessionStorage.setItem('sb_exit_shown', '1');
  };

  function showExitPopup() {
    if (exitShown) return;
    if (sessionStorage.getItem('sb_exit_shown')) return;
    // Don't show on cart or checkout
    if (window.location.pathname.includes('/cart') || window.location.pathname.includes('/checkout')) return;
    exitShown = true;
    document.getElementById('exit-popup').classList.add('open');
  }

  // Desktop: mouse leaves viewport top
  document.addEventListener('mouseleave', function (e) {
    if (e.clientY <= 10) showExitPopup();
  });

  // Mobile: back button / after 45s on page
  let mobileTimer;
  if ('ontouchstart' in window) {
    mobileTimer = setTimeout(showExitPopup, 45000);
  }

  // Close popup on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeExitPopup();
  });

  /* ===== MINI CART DRAWER ===== */
  window.openCartDrawer = function () {
    document.getElementById('cart-drawer').classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  window.closeCartDrawer = function () {
    document.getElementById('cart-drawer').classList.remove('open');
    document.body.style.overflow = '';
  };

  // Intercept all add-to-cart calls to also open drawer
  const originalAddToCart = window.addToCart;
  window.addToCart = function (variantId, quantity, btn) {
    if (!variantId) { alert('Please select all options.'); return; }
    const originalText = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
    .then(r => r.json())
    .then(item => {
      if (item.status) {
        showToast('⚠ ' + (item.description || 'Could not add to cart'));
      } else {
        refreshCart().then(() => {
          openCartDrawer();
          showToast('✓ ' + item.title + ' added to cart');
        });
      }
      if (btn) { btn.textContent = originalText; btn.disabled = false; }
    })
    .catch(() => {
      showToast('Could not add to cart. Please try again.');
      if (btn) { btn.textContent = originalText; btn.disabled = false; }
    });
  };

  /* ===== REFRESH CART (AJAX) ===== */
  function refreshCart() {
    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        // Update all cart counts in header
        document.querySelectorAll('.cart-count, .drawer-count').forEach(el => {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('.cart-btn').forEach(el => {
          if (el.tagName === 'BUTTON' || el.tagName === 'A') {
            el.innerHTML = 'Cart (<span class="cart-count">' + cart.item_count + '</span>)';
          }
        });
        // Update drawer subtotal
        const sub = document.getElementById('drawer-subtotal');
        if (sub) sub.textContent = formatMoney(cart.total_price);
        // Update drawer checkout button
        const chk = document.querySelector('.cart-drawer__checkout');
        if (chk) chk.textContent = 'Checkout — ' + formatMoney(cart.total_price) + ' →';
        // Refresh drawer items
        renderDrawerItems(cart);
        // Update free shipping bars
        updateShippingBars(cart.total_price);
        return cart;
      });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderDrawerItems(cart) {
    const container = document.getElementById('drawer-items');
    if (!container) return;
    if (cart.item_count === 0) {
      container.innerHTML = '<div class="drawer-empty">Your cart is empty</div>';
      return;
    }
    container.innerHTML = cart.items.map((item, i) => `
      <div class="drawer-item">
        <img class="drawer-item__img" src="${item.image}" alt="${item.title}" onerror="this.style.background='var(--mgray)'">
        <div class="drawer-item__info">
          <div class="drawer-item__name">${item.product_title}</div>
          ${item.variant_title !== 'Default Title' ? `<div class="drawer-item__variant">${item.variant_title}</div>` : ''}
          <div class="drawer-item__price">${formatMoney(item.final_line_price)}</div>
        </div>
        <button class="drawer-item__remove" onclick="updateCartLine(${i + 1}, 0, true)" aria-label="Remove">✕</button>
      </div>
    `).join('');
  }

  function updateShippingBars(totalCents) {
    const threshold = 20000;
    const pct = Math.min(100, (totalCents / threshold) * 100);
    document.querySelectorAll('.drawer-ship-fill, .cart-ship-progress__fill, .shipping-nudge__fill').forEach(el => {
      el.style.width = pct + '%';
    });
    const drawerText = document.querySelector('.drawer-ship-text');
    if (drawerText) {
      if (totalCents >= threshold) {
        drawerText.innerHTML = '🎉 You\'ve unlocked <strong>FREE shipping!</strong>';
      } else {
        const needed = formatMoney(threshold - totalCents);
        drawerText.innerHTML = `Add <strong>${needed}</strong> for <strong>FREE shipping</strong>`;
      }
    }
  }

  /* ===== UPDATE CART LINE ===== */
  window.updateCartLine = function (line, qty, refreshDrawer) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(r => r.json())
    .then(() => {
      if (refreshDrawer) {
        refreshCart();
      } else {
        window.location.reload();
      }
    });
  };

  /* ===== LIVE VISITOR COUNTER ===== */
  function injectLiveVisitors() {
    // Inject into product pages
    const priceEl = document.querySelector('.product-page__price');
    if (!priceEl) return;
    // Simulate 4–18 live viewers (seeded by product ID for consistency)
    const seed = parseInt(document.querySelector('[itemprop="name"]')?.textContent?.length || 10);
    const count = (seed % 14) + 4;
    const el = document.createElement('div');
    el.className = 'live-visitors';
    el.innerHTML = `<div class="live-dot"></div><span><strong>${count} people</strong> are viewing this right now</span>`;
    priceEl.parentNode.insertBefore(el, priceEl.nextSibling);

    // Animate count slightly over time
    setInterval(() => {
      const change = Math.random() > 0.5 ? 1 : -1;
      const current = parseInt(el.querySelector('strong').textContent);
      const next = Math.max(2, Math.min(24, current + change));
      el.querySelector('strong').textContent = next + ' people';
    }, 8000);
  }

  /* ===== SMART TOAST NOTIFICATIONS ===== */
  // Show social proof pop-ins (someone just bought...)
  const _firstNames = [
    'Sarah','Marcus','Emma','Jordan','Aisha','Chris','Taylor','Devon',
    'Priya','Liam','Zoe','Andre','Maya','Tyler','Jasmine','Ethan',
    'Brianna','Cameron','Nadia','Owen','Simone','Caleb','Fatima','Brandon',
    'Leila','Noah','Tanya','Isaiah','Kira','Darius','Sofia','Miles',
    'Amara','Jalen','Chloe','Malik','Destiny','Ryan','Keisha','Logan',
    'Aaliya','Trevor','Monique','Sean','Layla','Derek','Imani','Brett',
    'Yara','Marcus','Tiana','Corey','Luna','Jaylen','Nia','Austin'
  ];
  const _cities = [
    'New York','Los Angeles','Chicago','Miami','Atlanta','Seattle',
    'Houston','Phoenix','Philadelphia','San Antonio','Dallas','San Diego',
    'San Jose','Austin','Jacksonville','Denver','Boston','Nashville',
    'Detroit','Portland','Las Vegas','Memphis','Baltimore','Louisville',
    'Milwaukee','Albuquerque','Tucson','Fresno','Sacramento','Mesa',
    'Kansas City','Raleigh','Omaha','Cleveland','Minneapolis','Tulsa',
    'Tampa','Arlington','New Orleans','Bakersfield','Charlotte','Honolulu',
    'Anaheim','Riverside','Lexington','Stockton','St. Louis','Pittsburgh',
    'Anchorage','Cincinnati'
  ];
  const _products = [
    'ReNewZip Hoodie','EcoFlex Tee','FitFlex Leggings','6" Rebirth Shorts',
    'ActiveFit Shorts','ReNewFit Tee','5" ReviveFlex Shorts','ActiveFit Woven Shorts',
    'EcoFlex Tank','ReNewZip Hoodie (Black)','FitFlex Leggings (Blue)',
    'EcoFlex Tee (Moss)','Rebirth Shorts (Olive)','ReNewFit Tee (White)',
    'ActiveFit Shorts (Gray)','FitFlex Leggings (Black)'
  ];
  const _times = [
    'just now','1 minute ago','2 minutes ago','3 minutes ago','4 minutes ago',
    '5 minutes ago','6 minutes ago','8 minutes ago','10 minutes ago','12 minutes ago',
    '15 minutes ago','18 minutes ago','20 minutes ago','22 minutes ago','25 minutes ago',
    '28 minutes ago','30 minutes ago','35 minutes ago','40 minutes ago','45 minutes ago',
    '50 minutes ago','1 hour ago','1 hour ago','2 hours ago','2 hours ago'
  ];

  // Track last shown to avoid consecutive repeats
  var _lastBuyer = '';
  var _lastProduct = '';

  function _getRandom(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  function _buildBuyer() {
    var firstName, city, product;
    var attempts = 0;
    do {
      firstName = _getRandom(_firstNames);
      city = _getRandom(_cities);
      product = _getRandom(_products);
      attempts++;
    } while (attempts < 10 && (firstName + city === _lastBuyer || product === _lastProduct));
    _lastBuyer = firstName + city;
    _lastProduct = product;
    return {
      name: firstName + ' from ' + city,
      product: product,
      time: _getRandom(_times)
    };
  }

  function showSocialProofToast() {
    // Only on product or collection pages
    // Show on product, collection, and homepage
    var onRelevantPage = document.querySelector('.pdp, .product-page, .products-grid, .hp-hero, .collection-hero');
    if (!onRelevantPage) return;
    var buyer = _buildBuyer();
    const toast = document.createElement('div');
    toast.className = 'social-proof-toast';
    toast.innerHTML = `
      <div class="spt-icon">🛍</div>
      <div class="spt-text">
        <strong>${buyer.name}</strong> just purchased<br>
        <span>${buyer.product}</span>
        <div class="spt-time">${buyer.time}</div>
      </div>
      <button class="spt-close" onclick="this.parentNode.remove()">✕</button>
    `;
    document.body.appendChild(toast);
    setTimeout(() => toast.classList.add('show'), 100);
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 400);
    }, 5000);
  }

  // Add social proof toast styles dynamically
  const sptStyle = document.createElement('style');
  sptStyle.textContent = `
    .social-proof-toast {
      position: fixed; bottom: 80px; left: 24px; z-index: 500;
      background: var(--white); border: 1px solid var(--lgray);
      box-shadow: 0 8px 32px rgba(0,0,0,.12);
      display: flex; align-items: flex-start; gap: 12px;
      padding: 14px 16px; max-width: 280px;
      border-left: 3px solid var(--lime);
      transform: translateX(-120%);
      transition: transform .4s cubic-bezier(.25,.46,.45,.94);
    }
    .social-proof-toast.show { transform: translateX(0); }
    .spt-icon { font-size: 20px; flex-shrink: 0; }
    .spt-text { flex: 1; font-size: 12px; line-height: 1.55; }
    .spt-text span { color: var(--moss); font-weight: 600; }
    .spt-time { font-size: 10px; color: var(--gray); margin-top: 3px; letter-spacing: .06em; }
    .spt-close { background: none; border: none; font-size: 14px; color: var(--gray); cursor: pointer; flex-shrink: 0; padding: 0 0 0 4px; }
  `;
  document.head.appendChild(sptStyle);

  /* ===== BACK-IN-STOCK FORM ===== */
  function initBackInStock() {
    const addBtn = document.getElementById('add-to-cart-btn');
    if (addBtn && addBtn.disabled) {
      const form = document.createElement('div');
      form.className = 'bis-form';
      form.innerHTML = `
        <div class="bis-label">Get notified when back in stock</div>
        <div class="bis-row">
          <input class="bis-input" type="email" placeholder="Your email address">
          <button class="bis-btn" onclick="bisSubmit(this)">Notify Me</button>
        </div>
      `;
      addBtn.parentNode.insertAdjacentElement('afterend', form);

      const bisStyle = document.createElement('style');
      bisStyle.textContent = `
        .bis-form { margin-top: 14px; }
        .bis-label { font-size: 11px; font-weight: 600; letter-spacing: .1em; text-transform: uppercase; color: var(--gray); margin-bottom: 10px; }
        .bis-row { display: flex; gap: 0; }
        .bis-input { flex: 1; border: 1px solid var(--lgray); padding: 12px 14px; font-size: 12px; font-family: var(--B); }
        .bis-input:focus { outline: none; border-color: var(--black); }
        .bis-btn { background: var(--black); color: var(--white); border: none; padding: 12px 18px; font-size: 10px; font-weight: 700; letter-spacing: .18em; text-transform: uppercase; cursor: pointer; transition: background .2s; }
        .bis-btn:hover { background: var(--moss); }
      `;
      document.head.appendChild(bisStyle);
    }
  }

  window.bisSubmit = function(btn) {
    const input = btn.previousElementSibling;
    if (input && input.value && input.value.includes('@')) {
      btn.textContent = '✓ Done!';
      btn.style.background = 'var(--moss)';
      showToast('✓ We\'ll notify you when this is back in stock!');
    } else {
      input.style.borderColor = '#e00';
    }
  };

  /* ===== INIT ===== */
  document.addEventListener('DOMContentLoaded', function () {
    injectLiveVisitors();
    initBackInStock();

    // Show first social proof after 8s, then every 25s
    setTimeout(() => {
      showSocialProofToast();
      // Random interval 15-40s so it feels organic
      function scheduleNext() {
        var delay = 15000 + Math.floor(Math.random() * 25000);
        setTimeout(function() { showSocialProofToast(); scheduleNext(); }, delay);
      }
      scheduleNext();
    }, 8000);

    // Refresh cart state on load (keeps drawer in sync)
    refreshCart().catch(() => {});
  });

})();


// ── POST-PURCHASE REVIEW NUDGE ──
// Shows a review request toast if visitor lands on a page
// and has previously purchased (stored in localStorage)
(function() {
  // Mark purchase when cart empties after checkout
  document.addEventListener('DOMContentLoaded', function() {
    var prevCount = parseInt(localStorage.getItem('sb_cart_count') || '0');
    // Read cart count from DOM (Liquid not processed in .js files)
    var cartCountEl = document.querySelector('.cart-count, [data-cart-count], #cart-icon-btn');
    var currCount = cartCountEl ? parseInt(cartCountEl.textContent.replace(/[^0-9]/g,'') || '0') : 0;
    
    // Store current count
    localStorage.setItem('sb_cart_count', String(currCount));
    
    // If cart went to 0 from non-zero, likely just purchased
    if (prevCount > 0 && currCount === 0) {
      localStorage.setItem('sb_last_purchase', Date.now().toString());
    }
    
    // Check if 3+ days since last purchase — show review nudge
    var lastPurchase = parseInt(localStorage.getItem('sb_last_purchase') || '0');
    if (!lastPurchase) return;
    
    var daysSince = (Date.now() - lastPurchase) / (1000 * 60 * 60 * 24);
    var nudgeShown = sessionStorage.getItem('sb_review_nudge_shown');
    
    if (daysSince >= 3 && daysSince <= 30 && !nudgeShown) {
      sessionStorage.setItem('sb_review_nudge_shown', '1');
      setTimeout(function() {
        showToast('⭐ How did your recent order go? Leave a review and help others!');
      }, 8000);
    }
  });
})();
